import { post } from '@tencent/pmd-network';
import { DEFAULT_ADMIN_ID, DEFAULT_APP_ID } from './config';


export function getTimUnReadCount({
  acount,
  needObjResp = false,
}): Promise<number | {
    all: number;
    [key: string]: number;
  }> {
  return new Promise((resolve, reject) => {
    const reqData = {
      im_req: {
        Peer_Account: acount,
        appid: DEFAULT_APP_ID,
        admin_uid: DEFAULT_ADMIN_ID,
      },
    };
    post({
      url: '/pvpesport.sgamenes.commcgi.commcgi/GetUnreadMsg',
      reqData,
      showMsgToast: false,
    }).then((resp) => {
      let count = 0;
      if (!resp?.im_rsp || resp?.im_rsp?.ErrorCode) {
        reject(resp);
        return;
      }

      if (needObjResp) {
        const obj = (resp?.im_rsp?.C2CUnreadMsgNumList || []).reduce((acc, item) => ({
          ...acc,
          [item.Peer_Account]: item.C2CUnreadMsgNum || 0,
        }), {});

        resolve({
          all: resp?.im_rsp?.AllC2CUnreadMsgNum || 0,
          ...obj,
        });
        return;
      }

      if (acount) {
        count = resp?.im_rsp?.C2CUnreadMsgNumList?.[0]?.C2CUnreadMsgNum || 0;
      } else {
        count = resp?.im_rsp?.AllC2CUnreadMsgNum || 0;
      }
      resolve(count);
    })
      .catch((error) => {
        reject(error);
      });
  });
}
